import React, { Fragment } from "react";
import "./bunner.css";
const CoverBunner = ({ title, description }) => {
  return (
    <Fragment>
      <div className="container">
        <div className="row">
          <aside className="col-sm-12">
            <div className="card-banner  overlay-grad">
              <div className="card-body text-white">
                <h5 className="card-title text-bold">{title}</h5>
                <p className="card-text text-justify">{description}</p>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </Fragment>
  );
};

export default CoverBunner;
